import axios from 'axios'

import { ApiUrls, axiosConfig } from '../apiUrls';

export const GetAllFilterTypes = (data) => {
    return axios.get(ApiUrls.GET_FILTERS, axiosConfig())
}